import { debug as e, isInIframe as t } from "./initConfig.js";
import { version as n } from "../../version.js";
//#region src/utils/init/initCSS.ts
var r = (e) => !!document.head.querySelector(e), i = (e) => e.some(r), a = "default", o = [
	"rio",
	"man",
	"vw",
	"scania",
	"traton",
	"international",
	"wireframes"
], s = "data-brand", c = "data-uikit-brand-css", l = "data-uikit-theme-loading-style", u = (e) => e === "default" || o.includes(e), d = (e) => u(e) ? e : a, f = (e) => `uikit-theme-${e}.css`, p = () => "uikit-print-utilities.css", m = () => [p(), "rio-uikit-print-utilities.css"], h = (e, t = {}) => {
	let n = document.createElement("link");
	n.rel = "stylesheet", n.type = "text/css", n.href = e, Object.entries(t).forEach(([e, t]) => {
		n.setAttribute(e, t);
	}), document.head.appendChild(n);
}, g = () => {
	let e = /uikit-theme-(default|rio|man|vw|scania|traton|international|wireframes)\.css/;
	return [...document.querySelectorAll("link[rel=\"stylesheet\"]")].find((t) => {
		let n = t.href;
		return t.hasAttribute(c) || e.test(n);
	});
}, _ = () => d(document.documentElement.dataset.brand), v = (e) => {
	let t = d(e), n = g();
	return n && (n.href = n.href.replace(/uikit-theme-(default|rio|man|vw|scania|traton|international|wireframes)\.css/, f(t)), n.setAttribute(c, t)), document.documentElement.dataset.brand = t, t;
}, y = () => {
	let a = _();
	document.documentElement.dataset.brand = a, window.CSS?.supports?.("gap: 1px") || document.documentElement.classList.add("css-no-gap"), t && document.documentElement.classList.add("window-iframe");
	{
		document.documentElement.setAttribute("data-uikit-init", "");
		let e = document.createElement("style");
		e.setAttribute(l, ""), e.textContent = "\n            html[data-uikit-init] body {\n                visibility: hidden;\n            }\n        ", document.head.appendChild(e);
	}
	if (document.title?.includes("UIKIT Demo")) return;
	e("Checking for UIKIT CSS in document head.");
	let o = i([
		"link[href*=\"uikit-theme-default.css\"]",
		"link[href*=\"uikit-theme-rio.css\"]",
		"link[href*=\"rio-uikit.css\"]"
	]), s = r("style[data-vite-dev-id*=\"uikit.scss\"]"), u = i([
		"link[href*=\"uikit-theme-man.css\"]",
		"link[href*=\"uikit-theme-vw.css\"]",
		"link[href*=\"uikit-theme-scania.css\"]",
		"link[href*=\"uikit-theme-traton.css\"]",
		"link[href*=\"uikit-theme-international.css\"]",
		"link[href*=\"uikit-theme-wireframes.css\"]",
		"link[href*=\"man-uikit.css\"]",
		"link[href*=\"vw-uikit.css\"]",
		"link[href*=\"scania-uikit.css\"]",
		"link[href*=\"traton-uikit.css\"]",
		"link[href*=\"international-uikit.css\"]",
		"link[href*=\"wireframes-uikit.css\"]"
	]), d = document.documentElement.hasAttribute("data-print-styles"), g = i(m().map((e) => `link[href*="${e}"]`));
	o || s || u ? e("UIKIT CSS found in document head.") : (e("No UIKIT CSS found => append link tag to document head."), h(`https://uikit.developers.rio.cloud/${n}/${f(a)}`, { [c]: a })), d && !g && (e("data-print-styles found => append UIKIT print CSS link to document head."), h(`https://uikit.developers.rio.cloud/${n}/${p()}`));
}, b = () => {
	[...document.querySelectorAll("link[rel=\"stylesheet\"]")].forEach((e) => {
		let { href: t } = e;
		if (t.includes("uikit.developers.rio.cloud")) {
			let [, e] = new URL(t).pathname.split("/");
			t.includes("3.0.1") || console.warn(`You are using different UIKIT JS and CSS versions.
Your current JS version is ${n} and your current CSS version is ${e}.\nIf this is not on purpose, please fix it. Otherwise, this may lead to UI bugs.`);
		} else t.includes("cdn.rio.cloud/libs/rio-uikit") && console.error("You are still using an old \"cdn.rio.cloud\" css import. This will most likely cause major UI bugs! Please update to the CSS URLs as explained on https://uikit.developers.rio.cloud/#start/howto.");
	});
};
//#endregion
export { o as BRANDS, s as BRAND_DATA_ATTRIBUTE, a as DEFAULT_BRAND, b as checkCSSVersion, d as getBrand, _ as getDocumentBrand, y as initCSS, v as setDocumentBrand };

//# sourceMappingURL=initCSS.js.map